import Button from "@material-ui/core/Button";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";

export interface DialogSpecsProps {
  title: string;
  content?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export interface ConfirmationDialogProps extends DialogProps {
  dialogProps: DialogSpecsProps;
}

export class ConfirmationDialog extends React.Component<
  ConfirmationDialogProps
> {
  public render() {
    const { dialogProps } = this.props;

    return (
      <Dialog
        open={this.props.open}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
      >
        <DialogTitle id="confirmation-dialog-title">
          {dialogProps.title}
        </DialogTitle>
        <DialogContent>{dialogProps.content}</DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  private handleCancel = () => {
    this.props.dialogProps.onCancel();
  };

  private handleOk = () => {
    this.props.dialogProps.onConfirm();
  };
}
